export const SortingTypes = [
  // "Best Sellers",
  "Price (low to high)",
  "Price (high to low)",
];

export const QUIZ_TYPE = "haircare";
export const HEADER_TEXT = "Haircare Quiz";
export const RECOMMENDED_TEXT = "Here's what we recommend.";
export const START_OVER = "Start Over";
export const SORT_BY = "Sort by:";
export const RESULTS = "Results";
export const FILTER = "Filter";
export const VIEW_DETAILS = "View Details";
export const PRICE_RANGE = "Price Range";
export const RATING = "Rating";
export const GO_BUTTON = "Go";
export const BACK_BUTTON = "Back";
export const SELECT_ALL_THAT_APPLY_TITLE = "Select all that apply";
export const MIN_LABEL = "min";
export const MAX_LABEL = "max";
export const SKIP_NEXT_BUTTON = "Skip/Next";
export const HOME_SCREEN_QUESTION = "How do you want to explore?";
export const BY_HAIR_GOAL_BUTTON = "By hair goal";
export const BY_PRODUCT_TYPE_BUTTON = "By product type";
export const HOME_PAGE_TITLE_TEXT =
  "Let us help you find the right products to achieve your hair goals -because everyone’s hair has its own story";
export const VIRTUAL_HAIR_TRY_ON_TEXT =
  "Get inspired and have fun with our virtual hairstyle try-on experience.";
export const VIRTUAL_HAIR_TRY_ON_BUTTON = "Virtual try-on";
export const NO_RESULT_FOUND_TEXT =
  "There are no products available that match your criteria. Try adjusting the filters.";

export const VIRTUAL_HAIR_TRY_ON_LINK = "https://www.ulta.com/discover/vto/hair?origin=menu";
